export function params(key) {
  let search = window.location.search || window.location.hash
  if (!search || !key) {
    return ''
  }
  if (search[0] === '#') {
    search = search.split('?')[1] || ''
  }
  return new URLSearchParams(search).get(key)
}
